import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function TimeIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M16 31C7.72875 31 1 24.2713 1 16C1 7.72875 7.72875 1 16 1C24.2713 1 31 7.72875 31 16C31 24.2713 24.2713 31 16 31ZM16 4.75C9.7975 4.75 4.75 9.79625 4.75 16C4.75 22.2037 9.7975 27.25 16 27.25C22.2025 27.25 27.25 22.2037 27.25 16C27.25 9.79625 22.2037 4.75 16 4.75ZM22.25 16.625C22.25 15.59 21.41 14.75 20.375 14.75H17.25V9.125C17.25 8.09 16.4112 7.25 15.375 7.25C14.3388 7.25 13.5 8.09 13.5 9.125V16.625C13.5 17.66 14.3388 18.5 15.375 18.5H20.375C21.41 18.5 22.25 17.66 22.25 16.625Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
